export const formatPhoneNumber = (value) => {
  const replaced = value.replace(/\D/g, "");
  if (replaced.length === 0) return "";
  if (replaced.length <= 3) return `(${replaced}`;
  if (replaced.length <= 6)
    return `(${replaced.slice(0, 3)}) ${replaced.slice(3)}`;
  return `(${replaced.slice(0, 3)}) ${replaced.slice(3, 6)}-${replaced.slice(
    6,
    10
  )}`;
};
